import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=531dfa36&scoped=true"
import script from "./audit.vue?vue&type=script&lang=js"
export * from "./audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531dfa36",
  null
  
)

export default component.exports